/** Shared motion timings for workspace pine dock + node sheets (kept in sync). */
export const WORKSPACE_OVERLAY_EASE = [0.22, 1, 0.36, 1] as const;

export const WORKSPACE_OVERLAY_TRANSITION = {
  duration: 0.36,
  ease: WORKSPACE_OVERLAY_EASE,
} as const;

/** Wait for sheet/dock exit animations before mounting another overlay. */
export const WORKSPACE_OVERLAY_EXIT_MS = Math.round(
  WORKSPACE_OVERLAY_TRANSITION.duration * 1000 + 40
);

export const WORKSPACE_SHEET_TRANSITION = WORKSPACE_OVERLAY_TRANSITION;
export const WORKSPACE_PINE_DOCK_TRANSITION = WORKSPACE_OVERLAY_TRANSITION;

/** Sheet slides in from the right; exits back to the right. */
export const WORKSPACE_SHEET_MOTION = {
  initial: { x: "100%", opacity: 0.92 },
  animate: { x: 0, opacity: 1 },
  exit: { x: "100%", opacity: 0.92 },
} as const;

/** Dock (both pine cards) rises from the bottom edge as one unit. */
export const WORKSPACE_PINE_DOCK_MOTION = {
  initial: { y: "110%", opacity: 0.95 },
  animate: { y: 0, opacity: 1 },
  exit: { y: "110%", opacity: 0.95 },
} as const;
